// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__10RDW","consentsList":"PatientConsents_consentsList__31IFe","consentsListEmpty":"PatientConsents_consentsListEmpty__3DFwK"};